var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M21.906 1.262c-2.02-.654-6.772-.475-7.96 1.069c-3.089.059-6.713 2.851-7.188 6.535c-.47 3.645.578 5.338.951 8.079c.422 3.106 2.168 4.099 3.564 4.515C13.281 24.114 15.415 24 19 24c7 0 10.334-4.684 10.629-12.639c.178-4.812-2.645-8.456-7.723-10.099z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FA743E",
    d: "M27 21H9a4 4 0 0 0-4 4v11h26V25a4 4 0 0 0-4-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC5D",
    d: "M25.904 11.734c-.677-.938-1.545-1.693-3.446-1.96c.713.327 1.396 1.455 1.485 2.079c.089.624.178 1.129-.386.505c-2.261-2.499-4.723-1.515-7.163-3.041c-1.703-1.067-2.222-2.247-2.222-2.247s-.208 1.574-2.792 3.178c-.749.465-1.643 1.501-2.139 3.03c-.356 1.099-.246 2.079-.246 3.754c0 4.889 4.029 9 9 9s9-4.147 9-9c0-3.041-.318-4.229-1.091-5.298z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD551F",
    d: "M10 27h1v9h-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCAB40",
    d: "M4.702 26.495l-.283-.059h-.511c0-.058.023-.112.035-.169a.994.994 0 0 1-.458-1.048c.112-.542.643-.89 1.186-.779l2.091.433h1.676c.863 0 1.562.7 1.562 1.564V28H6.253s-1.481-.669-1.551-1.505z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC5D",
    d: "M0 25.655c0-.432.35-.782.781-.782l4.69.782h3.747c.432 0 .781.351.781.781V28H5L.781 26.437S0 26.087 0 25.655z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FA743E",
    d: "M4 36h6v-8H5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD551F",
    d: "M25 27h1v9h-1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCAB40",
    d: "M31.298 26.495l.283-.059h.511c0-.058-.023-.112-.035-.169a.994.994 0 0 0 .458-1.048a1.003 1.003 0 0 0-1.185-.779l-2.091.433h-1.676c-.863 0-1.562.7-1.562 1.564V28h3.747c-.001 0 1.48-.669 1.55-1.505z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC5D",
    d: "M36 25.655a.782.782 0 0 0-.781-.782l-4.691.782h-3.747a.781.781 0 0 0-.781.781V28h5l4.219-1.563s.781-.35.781-.782z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FA743E",
    d: "M32 36h-6v-8h5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M19 19.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1zm1.5 3.5H20a.5.5 0 0 1 0-1h.5a.5.5 0 0 1 0 1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#662113",
    d: "M14 16a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1zm8 0a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.19e829491c004dda816550d37811e4f1.svg";
export { ForwardRef as ReactComponent };